
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsAdvPromoHdAppDialog extends Serenity.EntityDialog<PsAdvPromoHdAppRow, any> {
        protected getFormKey() { return PsAdvPromoHdAppForm.formKey; }
        protected getIdProperty() { return PsAdvPromoHdAppRow.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoHdAppRow.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoHdAppRow.nameProperty; }
        protected getService() { return PsAdvPromoHdAppService.baseUrl; }
        protected getDeletePermission() { return PsAdvPromoHdAppRow.deletePermission; }
        protected getInsertPermission() { return PsAdvPromoHdAppRow.insertPermission; }
        protected getUpdatePermission() { return PsAdvPromoHdAppRow.updatePermission; }

        protected form = new PsAdvPromoHdAppForm(this.idPrefix);

        
        
       
        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            
            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Approve",
                    hint: "Approve and Save [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        
                        Q.confirm(
                           '  ยืนยันการอนุมัติ'+ "\r\n" +
                           'และเปิดใช้งานโปรโมชั่น'+"\r\n" +
                           'หากต้องการยกเลิกการอนุมัติ โปรดปิดสถานะการใช้งานก่อน',
                            () => {
                                this.form.PromoApproveFg.value = "1";
                                this.form.PromoStatus.value = "1";
                                this.form.PromoApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
                {
                    title: "Reject",
                    hint: "Rejected and Save",
                    separator: false,
                    cssClass: "button-save-reject",
                    icon: "fa fa-times-circle text-red",
                    // hotkey: 'alt+s',
                    onClick: (e) => {
                        Q.confirm(
                            "ไม่อนุมัติรายการนี้ " + "\r\n" +
                            ' ยืนยันการบันทึก',
                            () => {
                                this.form.PromoApproveFg.value = "0";
                                this.form.PromoApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            
            this.form.ItemExList.myPassValue1 = this.entity.PmGroupId
            if (this.isEditMode){
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('button-apply').hide();
                var date = $.datepicker.formatDate('yymmdd', new Date());
                var effdate = this.entity.EndPromoDate
                var a = effdate.split('T')[0];
                var effectdate = a.split('-')[0] + a.split('-')[1] + a.split('-')[2]
                // Q.confirm(effectdate + date, () => { });
                if (effectdate < date) {
                // if (this.entity.PromoApproveFg == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-reject').hide();
                    this.toolbar.findButton('button-save-cancle').hide();
                // }else if (this.entity.PromoApproveFg == 0) {
                //     this.toolbar.findButton('button-save-cancle').hide();
                //     this.toolbar.findButton('button-save-approve').hide();
    
                //     // this.toolbar.findButton('button-save-reject').hide();                  
                // }else{
                //     this.toolbar.findButton('button-save-approve').hide();
    
                //     this.toolbar.findButton('button-save-cancle').hide();     
                //     //ต้องการเพิ่มซ่อน from.ApproveFg
                // }
                }else{
                if (this.entity.PromoApproveFg == 1) {
                    if (this.entity.PromoStatus == 1) {
                        this.toolbar.findButton('button-save-approve').hide();
                        // this.toolbar.findButton('button-save-cancle').hide();
                        this.toolbar.findButton('button-save-reject').hide();
                    } else {
                        this.toolbar.findButton('button-save-approve').hide();
                        this.toolbar.findButton('button-save-reject').hide();
    
                    }
                }
                else if (this.entity.PromoApproveFg == 0) {
                    // this.toolbar.findButton('button-save-cancle').hide();
                    this.toolbar.findButton('button-save-reject').hide();
                }
                else {
                    // this.toolbar.findButton('button-save-cancle').hide();
                    //ต้องการเพิ่มซ่อน from.ApproveFg
                }
                }}
        }

    }
}